import {Injectable} from '@angular/core';

/**
 * Translations for shared elements
 */
@Injectable()
export class SharedTranslationsService {
  public i18nErrorFetchingCountries: any = $localize`:@@alertService.alert.error.fetchingCountries:Error occurred. Could not fetch countries.`;
  public i18nUserCreated: any = $localize`:@@alertService.warning.userCreated:User has been successfully created.`;
  public i18nUserUpdated: any = $localize`:@@alertService.warning.userUpdated:User has been successfully updated.`;
  public i18nErrorUsernameExists: any = $localize`:@@alertService.warning.usernameExists:This username already exists.`;
  public i18nErrorAtLeastOne: any = $localize`:@@alertService.error.selectAtLeastOne:You must select at least one club.`;
  constructor() { }
}
